module.exports = __webpack_public_path__ + "media/images/ceremony/plans/2/hall-list/plan-ceremony-lineup-kanto-1-0ff9c272fab863e97961952eca59e479.png";